export function setDecimalPoints(n, decimalPoints) {
  return Number(Math.round(parseFloat(n + 'e' + decimalPoints)) + 'e-' + decimalPoints)
}
